module.exports = __webpack_public_path__ + "static/img/inte4.5da94f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/integrate/inte4.png
// module id = lhkX
// module chunks = 0